module.exports = __webpack_public_path__ + "static/img/32.ca7a7e8b.png";